import environment from './environment';

const mocks = {
  oauth: {
    enabled: environment.isLocal,
  },
};

export default mocks;
